import React from "react";
import styled from "styled-components";
import {BorderGradient} from "../../styles/globalStyles";


const CardWrapper = styled(BorderGradient)`
  width: 300px;
  height: 250px;
  border-radius: 50px;
`;
const StyledImage = styled.div`
  margin-bottom: 20px;
`;
const StyledContent = styled.div`
  padding: 3vh 3vw;
`;
const Paragraph = styled.p`
  font-size: 16px;
  font-weight: bold;
`;


const Card = ({image, text}) => (
  <CardWrapper>
    <StyledContent>
      <StyledImage>{image}</StyledImage>
      <Paragraph>{text}</Paragraph>
    </StyledContent>
  </CardWrapper>

);
export default Card;
